<!-- Preview Mode -->
<div *ngIf="mode === 'preview'" [ngStyle]="getPreviewStyles()" class="p-6 rounded-lg">
  <!-- Heading -->
  <div *ngIf="getHeading()" [ngClass]="getTitlePositionClass()" class="mb-4">
    <h3 class="text-xl font-bold" [style.color]="getHeadingColor()">{{ getHeading() }}</h3>
  </div>

  <!-- Description -->
  <p *ngIf="getDescription()" class="text-sm mb-4 opacity-70" [style.color]="getTextColor()">
    {{ getDescription() }}
  </p>

  <!-- Form Preview (disabled) -->
  <div class="max-w-lg space-y-3" [class.mx-auto]="getTitlePosition() === 'center'">
    <div *ngFor="let field of getFields()" class="w-full" [ngClass]="{'sm:w-1/2 sm:inline-block sm:pr-2': field.width === 'half'}">
      <!-- Label -->
      <label *ngIf="field.type !== 'checkbox'" class="block text-xs font-medium mb-1 opacity-60" [style.color]="getTextColor()">
        {{ field.label }}
        <span *ngIf="field.required" class="text-red-500 ml-0.5">*</span>
      </label>

      <!-- Text/Email/Tel Input -->
      <input
        *ngIf="field.type === 'text' || field.type === 'email' || field.type === 'tel'"
        [type]="field.type"
        [placeholder]="field.placeholder"
        disabled
        class="w-full px-3 py-2 text-sm rounded border border-gray-300 bg-gray-50 text-gray-400 cursor-not-allowed"
      />

      <!-- Textarea -->
      <textarea
        *ngIf="field.type === 'textarea'"
        [placeholder]="field.placeholder"
        disabled
        rows="3"
        class="w-full px-3 py-2 text-sm rounded border border-gray-300 bg-gray-50 text-gray-400 cursor-not-allowed resize-none"
      ></textarea>

      <!-- Select -->
      <select
        *ngIf="field.type === 'select'"
        disabled
        class="w-full px-3 py-2 text-sm rounded border border-gray-300 bg-gray-50 text-gray-400 cursor-not-allowed"
      >
        <option>{{ field.placeholder || 'Selecteer...' }}</option>
        <option *ngFor="let opt of field.options">{{ opt }}</option>
      </select>

      <!-- Checkbox -->
      <label *ngIf="field.type === 'checkbox'" class="flex items-center gap-2 text-sm opacity-60" [style.color]="getTextColor()">
        <input type="checkbox" disabled class="w-4 h-4 rounded" />
        {{ field.label }}
        <span *ngIf="field.required" class="text-red-500 ml-0.5">*</span>
      </label>
    </div>

    <!-- Submit button preview -->
    <button disabled class="px-6 py-2 rounded text-sm font-medium text-white bg-indigo-600 opacity-70 cursor-not-allowed mt-2">
      {{ getSubmitButtonText() }}
    </button>
  </div>

  <!-- Empty state -->
  <div *ngIf="getFields().length === 0" class="text-center py-8 text-gray-400">
    <svg class="w-10 h-10 mx-auto mb-2 opacity-40" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25z" />
    </svg>
    <p class="text-sm">Geen velden geconfigureerd</p>
    <p class="text-xs mt-1">Voeg velden toe via het zijpaneel</p>
  </div>
</div>
